import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createQuotationSellerToAdmin, type CreateQuotationSellerToAdminPayload } from "@/lib/api/quotation.api"
import { useAuthStore } from "@/store/auth.store"

export function useCreateQuotation() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateQuotationSellerToAdminPayload) => {
      if (!accessToken) throw new Error("Not authenticated")
      return createQuotationSellerToAdmin(payload, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["seller-rfqs"] })
    },
    onError: (error: Error) => {
      console.error("Quotation submission failed:", error.message)
    },
  })
}
